export const colors = {
  primary: '#3800F2',
  gray: {
    v100: '#F5F5F5',
    v200: '#E2E2E2', // @deprecated
    v300: '#C4C4C4',
    v400: '#BABABA', // @deprecated
    v500: '#AAAAAA', // @deprecated
    v600: '#767676',
    v700: '#605F5F',
    v800: '#393939',
    v900: '#000000', // @deprecated
  },
  status: {
    error: '#E92215',
    informative: '#0F3CD9',
    success: '#1DB469',
  },
  black: '#000000',
  white: '#FFFFFF',
}
